import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setResponsive } from '../redux/actions/responsiveActions';

const MOBILE_BREAKPOINT = 768;

/**
 * Detects viewport width and dispatches isMobile to Redux.
 * Debounced on resize to avoid excessive dispatches.
 */
export const useResponsiveDetector = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const checkWidth = () => {
      const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
      dispatch(setResponsive(isMobile));
    };

    // Check immediately on mount
    checkWidth();

    // Debounce resize events
    let timeoutId;
    const handleResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(checkWidth, 150);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(timeoutId);
    };
  }, [dispatch]);
};
